import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initI18n } from './i18n';
import { initProgress, readLegacyLang } from './engine/store';
import { LANG_KEY } from './data/srs';
import App from './App';
import './styles/app.css';

/* Progress first: it repairs a saved cursor from before blocks were inserted,
   and it knows the language chosen on the original single-file page. That
   choice is migrated once into the detector's own key, so the toggle is the
   only thing that writes it from here on. */
initProgress();
const legacyLang = readLegacyLang();
if (legacyLang && !localStorage.getItem(LANG_KEY)) localStorage.setItem(LANG_KEY, legacyLang);

/* i18next holds the active language; the tables are inline, so this resolves
   before the first render and no component ever sees a raw key. */
await initI18n();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
